import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isNil, get, cloneDeep } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import withRouter from '../../../lib/withRouter'
import actions from '../../../actions/Censuses'
import alert from '../../../alert'
import CensusesSelectFieldComponent from '../common/CensusesSelectFieldComponent'
import CensusForm from './CensusForm'

export class CensusEdit extends Component {
  static propTypes = {
    show: PropTypes.func.isRequired,
    update: PropTypes.func,
    reset: PropTypes.func.isRequired,
    index: PropTypes.func.isRequired,
    indexReset: PropTypes.func.isRequired,
    showReset: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    records: PropTypes.array,
    needsCensus: PropTypes.bool,
    attributes: PropTypes.object,
    updated: PropTypes.bool.isRequired,
    params: PropTypes.object,
    history: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.index()
    this.props.show(this.props.params.id)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.id !== this.props.params.id || this.props.updated) {
      this.props.reset()
      this.props.indexReset()
      this.props.index()
      this.props.showReset()
      this.props.show(this.props.params.id)
    }
  }

  componentWillUnmount() {
    this.props.reset()
    this.props.indexReset()
    this.props.showReset()
  }

  get initialValues() {
    const attributes = cloneDeep(this.props.attributes)

    attributes.families_attributes = get(attributes, 'families', []).map((originalFamily) => {
      const f = originalFamily
      f.members_attributes = f.members
      delete f.members
      return f
    })

    delete attributes.families

    return attributes
  }

  handleSubmit = (values) => {
    this.props.update(this.props.params.id, values)
  }

  handleCensusChange = (name, value) => {
    if (value === 'NewCensus') {
      return this.props.history('/censuses/new')
    }
    return this.props.history(`/censuses/${value}/edit`)
  }

  render() {
    const {
      generalError,
      resourceErrors,
      needsCensus
    } = this.props

    const requestInProgress = this.props.requestInProgress === true

    if (!isNil(generalError)) {
      alert(generalError)
    }

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    if (needsCensus) { return null }

    return (
      <div className="content">
        <CensusesSelectFieldComponent
          value={this.props.params.id}
          handleChange={this.handleCensusChange}
          displayNewCensus
          censuses={this.props.records}
        />

        <CensusForm
          onSubmit={this.handleSubmit}
          errors={errors}
          initialValues={this.initialValues}
          submitLabel="Update Census"
          requestInProgress={requestInProgress}
          createImport={this.handleImport}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.censuses.update
  const showSlice = state.censuses.show
  const indexSlice = state.censuses.index

  return {
    needsCensus: (!isNil(showSlice.generalError) || isNil(showSlice.attributes)),
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    requestInProgress: slice.requestInProgress,
    attributes: showSlice.attributes,
    showRequestInProgress: showSlice.requestInProgress,
    updated: slice.updated,
    records: indexSlice.records
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  update: actions.update.main,
  reset: actions.update.reset,
  show: actions.show.main,
  showReset: actions.show.reset,
  index: actions.index.main,
  indexReset: actions.index.reset
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CensusEdit))
